
































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import axios from "@/api/AuthAPI/auth-request-api";
import { splitString } from "@/services/strings";

import Progress from "./progress.vue";
import StandartModal from "@/components/app/standart-modal.vue";

import { size, type } from "@/config/files.config.json";
import { pics } from "@/config/host.config";
import { AxiosResponse } from "axios";

interface IWH {
  width: number;
  height: number;
}

interface IImageParams {
  poster_name: string | null;
  lang: string | undefined;
  path: string;
  name: boolean;
  resizewidth: number | undefined;
  resizeheight: number | undefined;
}

@Component({
  components: {
    StandartModal,
    "progress-component": Progress,
  },
})
export default class UploadingImageToServer extends Vue {
  @Prop({ type: String, default: null }) upload!: string;
  @Prop({ type: String, default: null }) folder!: string;
  @Prop({ type: String, default: null }) image!: string;
  @Prop({ type: String, default: "/api/upload" }) host!: string;
  @Prop({ type: String, default: null }) locale!: string;
  @Prop({ type: Object, default: null }) widthHeight!: IWH;
  @Prop({ type: Boolean, default: false }) sawe!: boolean;
  @Prop({ type: Boolean, default: true }) btn_show!: boolean;
  @Prop({ type: Boolean, default: false }) hidePreview!: boolean;

  file: null | File = null;
  show_poster = false;
  poster_name = "";
  poster_preview: string | null | ArrayBuffer = null;
  saweNameToggle = this.sawe;

  // progress
  poster_prodress_variant = "primary";
  poster_value_progress = 0;
  poster_progress = false;

  size_falid = true;
  type_falid = true;

  $refs!: {
    file: HTMLInputElement;
  };

  handleFileUpload(): void {
    this.file = this.$refs.file.files ? this.$refs.file.files[0] : null;
    this.uploadFormData(this.file);
  }

  async uploadFormData(poster: File | null): Promise<void> {
    this.show_poster = false;
    this.poster_progress = false;
    this.poster_value_progress = 0;
    if (!poster) return;
    this.$nextTick(() => {
      this.poster_progress = true;
    });
    if (!this.file) {
      this.poster_prodress_variant = "danger";
      this.size_falid = true;
      this.type_falid = false;
      return;
    }
    if (!this.getFileFormat(this.file.type)) {
      this.poster_prodress_variant = "danger";
      this.size_falid = false;
      this.type_falid = true;
      return;
    }
    if (this.file.size <= size.image) {
      this.size_falid = true;
      this.type_falid = true;
      this.poster_prodress_variant = "primary";

      let formData = new FormData();
      formData.append("poster", poster);

      let posterName = "";
      if (this.saweNameToggle && this.$isRoot)
        posterName = this.poster_name ? this.poster_name : this.file.name;

      const params: IImageParams = {
        poster_name: posterName ? posterName : null,
        lang: this.locale ? this.locale : undefined,
        path: this.folder,
        name: this.saweNameToggle,
        resizewidth: this.widthHeight ? this.widthHeight.width : undefined,
        resizeheight: this.widthHeight ? this.widthHeight.height : undefined,
      };

      const config = {
        onDownloadProgress: (event: ProgressEvent) => {
          this.poster_value_progress = Math.round(
            (event.loaded * 100) / event.total
          );
        },
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: params,
      };
      const uri = `${pics.mainAPI}${this.host}`;
      axios
        .post(uri, formData, config)
        .then((res: AxiosResponse) => {
          if (res.status === 200) {
            this.poster_name = res.data;
            this.poster_preview = this.$getWebImage(
              res.data,
              this.widthHeight ? this.folder + "/full" : this.folder
            );
            console.log("update image: " + this.poster_name);
            this.$emit("updatePoster", this.poster_name);
            this.$bvModal.hide(`${this.upload}Modal`);
          }
        })
        .catch((e) => {
          console.log(e);
          this.poster_prodress_variant = "danger";
        });
    }
  }

  getFileFormat(string: string | undefined): boolean {
    if (!string) return false;
    const split_arr = splitString(string, "/");
    return type.image.includes(split_arr[split_arr.length - 1]);
  }

  @Watch("file")
  previewPosterFiles(): void {
    const reader = new FileReader();
    if (!this.file || !this.getFileFormat(this.file.type)) {
      this.show_poster = false;
      return;
    }
    this.show_poster = true;
    reader.readAsDataURL(this.file);
  }

  @Watch("image")
  updatePoster(): void {
    if (!this.image) return;
    this.poster_name = this.image;
    this.poster_preview = this.$getWebImage(
      this.image,
      this.widthHeight ? this.folder + "/full" : this.folder
    );
    this.show_poster = true;
  }

  onReset(): void {
    this.file = null;
    this.show_poster = false;
    this.poster_name = "";
    this.poster_preview = null;
    this.saweNameToggle = this.sawe;
  }

  mounted(): void {
    this.updatePoster();
  }
}
